import { connect } from 'react-redux';
import Forgot from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
